import graphql__a0750b9fafba848f7825 from "./__generated__/Subscription_subscribable.graphql.js";import { useCallback, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import { defineMessages } from "react-intl";

import ButtonWithCounter from "../Buttons/ButtonWithCounter";
import { useFormatMessage } from "../Intl/Context";
import { unsubscribe } from "../../mutations/UnsubscribeMutation";
import { useAlert } from "../Alerts/withAlert";
import { ALERT_TYPE_ERROR, ALERT_TYPE_SUCCESS } from "../Alerts/Alert";
import SubscriptionModal from "../Subscriptions/SubscriptionModal";
import Tooltip from "../Tooltip/Tooltip";
import classNames from "classnames";

const Subscription = ({ hideLabel = false, ...props }) => {
  const subscribable = useFragment(Subscription_subscribable, props.subscribable);
  const viewer = useSelector(({ viewer }) => viewer);

  const t = useFormatMessage();
  const labels = {
    subscribe: t(intlMessages.subscribe),
    subscribeTooltipContent: t(intlMessages.subscribeTooltipContent),
    unsubscribe: t(intlMessages.unsubscribe),
    unsubscribeTooltipContent: t(intlMessages.unsubscribeTooltipContent),
    successMessage: t(intlMessages.successMessage)
  };
  const [isSubscriptionAvailable, setSubscriptionAvailability] = useState(false);

  const { showAlert } = useAlert();

  const { id, alreadySubscribed, subscribersCount } = subscribable || {};

  const onUnsubscribeResponse = useCallback(
    response => {
      if (response.unsubscribe.success) {
        showAlert({
          message: labels.successMessage,
          type: ALERT_TYPE_SUCCESS
        });

        props.onRequestClose;
      } else {
        showAlert({
          message: response.unsubscribe.notice,
          type: ALERT_TYPE_ERROR
        });
      }
    },
    [labels.successMessage, props.onRequestClose, showAlert]
  );

  const toggleSubscriptionAvailability = useCallback(() => {
    setSubscriptionAvailability(!isSubscriptionAvailable);
  }, [isSubscriptionAvailable]);

  const handleButtonClick = useCallback(() => {
    if (alreadySubscribed) {
      unsubscribe(id, onUnsubscribeResponse);
    } else {
      toggleSubscriptionAvailability();
    }
  }, [alreadySubscribed, id, onUnsubscribeResponse, toggleSubscriptionAvailability]);

  if (!subscribable || !subscribable.allowSendingNotificationOnContentUpdate) {
    return null;
  }

  const buttonLabel =
    !hideLabel && (alreadySubscribed ? labels.unsubscribe : labels.subscribe);
  const tooltipContent = alreadySubscribed
    ? labels.unsubscribeTooltipContent
    : labels.subscribeTooltipContent;

  const className = classNames(props.className);

  return (
    <>
      <Tooltip content={tooltipContent}>
        <ButtonWithCounter
          className={className}
          buttonClassName="btn-primary-inverse"
          onClick={handleButtonClick}
          type="button"
          label={buttonLabel}
          iconClassName="fa fa-bell margin-right-none"
          iconPosition="before"
          count={subscribersCount}
          size="sm"
        />
      </Tooltip>

      {!alreadySubscribed && isSubscriptionAvailable && (
        <SubscriptionModal
          viewer={viewer}
          onRequestClose={toggleSubscriptionAvailability}
          subscribable={subscribable}
        />
      )}
    </>
  );
};

const Subscription_subscribable = graphql__a0750b9fafba848f7825;

export default Subscription;

const intlMessages = defineMessages({
  subscribe: {
    id: "subscription.subscribe",
    defaultMessage: "S'abonner"
  },
  unsubscribe: {
    id: "subscription.unsubscribe",
    defaultMessage: "Se désabonner"
  },
  subscribeTooltipContent: {
    id: "subscription.subscribeTooltipContent",
    defaultMessage: "Cliquez ici pour vous abonner aux mises à jour de la page"
  },
  unsubscribeTooltipContent: {
    id: "subscription.unsubscribeTooltipContent",
    defaultMessage: "Cliquez ici pour vous désabonner des mises à jour de la page"
  },
  successMessage: {
    id: "subscription.successMessage",
    defaultMessage: "Désabonnement effectué"
  }
});
